/**
 * Client for the card-link-prefs action on /api/account (migration 048).
 *
 * Passive card auto-stamping: once a customer's stamp is matched to a card
 * payment, later payments with that same card earn a stamp automatically.
 * Turning it off also deletes every card link already held for that
 * customer — see CardLinkSettings for the UI and docs/legal/PRIVACY_POLICY.md
 * §3 ("Your card, indirectly") for the promise this keeps.
 */
import { apiFetch, ApiError } from './api-client';

export interface CardLinkPrefsResult {
  optOut: boolean;
  linksForgotten: number;
}

export async function setCardAutoStamp(optOut: boolean): Promise<CardLinkPrefsResult> {
  return apiFetch<CardLinkPrefsResult>('/api/account', { action: 'card-link-prefs', optOut });
}

// Server error codes -> plain-language copy for the toggle. Raw server
// strings never reach the screen: anything not in this map (network hiccup,
// unmapped 5xx) falls back to a generic message — never a bare "Error".
const ERROR_COPY: Record<string, string> = {
  rate_limited: "That's a few changes in a row — wait a moment and try again.",
  links_not_cleared:
    "Your preference was saved, but we couldn't confirm the old cards were deleted yet. Try again in a moment.",
};

export function cardLinkErrorCopy(e: unknown): string {
  if (e instanceof ApiError && ERROR_COPY[e.message]) return ERROR_COPY[e.message];
  return "Couldn't save that change — check your connection and try again.";
}
